<template>
  <div>
    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog
        as="div"
        class="fixed inset-0 flex bg-dark-blue z-40 md:hidden"
        @close="sidebarOpen = false"
      >
        <TransitionChild
          as="template"
          enter="transition-opacity ease-linear duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-dark-blue bg-opacity-75" />
        </TransitionChild>
        <TransitionChild
          as="template"
          enter="transition ease-in-out duration-300 transform"
          enter-from="-translate-x-full"
          enter-to="translate-x-0"
          leave="transition ease-in-out duration-300 transform"
          leave-from="translate-x-0"
          leave-to="-translate-x-full"
        >
          <div
            class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-dark-blue"
          >
            <TransitionChild
              as="template"
              enter="ease-in-out duration-300"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="ease-in-out duration-300"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <div class="absolute top-0 right-0 -mr-12 pt-2">
                <button
                  type="button"
                  class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  @click="sidebarOpen = false"
                >
                  <span class="sr-only">Close sidebar</span>
                  <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
                </button>
              </div>
            </TransitionChild>
            <div class="flex-shrink-0 flex items-center px-4">
              <img
                class="h-8 w-auto"
                src="@/assets/logo-iso-circle.svg"
                alt="Logo Perfit"
              />
            </div>
            <div class="mt-5 flex-1 h-0 overflow-y-auto">
              <nav class="px-2 space-y-1">
                <router-link
                  v-for="item in routesSidebar"
                  :key="item.name"
                  :to="item.path"
                  :class="[
                    item.name == $route.name
                      ? 'bg-dark-blue text-white'
                      : 'text-white hover:bg-sky-blue',
                    'group flex items-center px-2 py-2 text-base font-medium rounded-md',
                  ]"
                >
                  <component
                    :is="item.icon"
                    class="mr-4 flex-shrink-0 h-6 w-6 text-white"
                    aria-hidden="true"
                  />
                  {{ item.name }}
                  <span
                    v-if="item.tag"
                    class="ml-2 px-1.5 py-0.5 rounded-full bg-sky-blue text-white text-xs font-semibold"
                  >
                    {{ item.tag }}
                  </span>
                </router-link>
                <router-link to="">Test</router-link>
              </nav>
            </div>
          </div>
        </TransitionChild>
        <div class="flex-shrink-0 w-14" aria-hidden="true">
          <!-- Dummy element to force sidebar to shrink to fit close icon -->
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex flex-col flex-grow pt-5 bg-nimbus-blue overflow-y-auto">
        <div class="mt-5 flex-1 flex flex-col">
          <nav class="flex-1 px-2 pb-4 space-y-1">
            <router-link
              v-for="item in routesSidebar"
              :key="item.name"
              :to="item.path"
              :class="[
                item.name == $route.name
                  ? 'bg-dark-blue text-white'
                  : 'text-white hover:bg-dark-blue',
                'group flex items-center px-2 py-2 text-sm font-medium rounded-md',
                item.name === 'Logout' ? 'hidden' : '',
              ]"
            >
              <component
                :is="item.icon"
                class="mr-3 flex-shrink-0 h-6 w-6 text-white"
                aria-hidden="true"
              />
              {{ item.name }}
              <span
                v-if="item.tag"
                class="ml-2 px-1.5 py-0.5 rounded-full bg-sky-blue text-white text-xs font-semibold"
              >
                {{ item.tag }}
              </span>
            </router-link>
          </nav>
        </div>
      </div>
    </div>
    <div class="md:hidden md:pl-64 flex flex-col flex-1 border-b-2">
      <div
        class="sticky top-0 z-10 flex-shrink-0 flex items-center h-16 hadow bg-white"
      >
        <button
          type="button"
          class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-inset focus:ring-sky-blue md:hidden"
          @click="sidebarOpen = true"
        >
          <span class="sr-only">Open sidebar</span>
          <MenuAlt2Icon class="h-6 w-6" aria-hidden="true" />
        </button>
        <h3 class="text-dark-blue font-semibold ml-4">Internal Tools</h3>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

// Icons
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { MenuAlt2Icon } from "@heroicons/vue/outline";
import { XIcon } from "@heroicons/vue/solid";

// Routes
import { routesSidebar } from "@/types/router.type";

const sidebarOpen = ref(false);
</script>
